/* this file is transformed by vux-loader */
/* eslint-disable */
import _regeneratorRuntime from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _components;

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Form, Field, Button, Uploader } from "vant";
import Api from "@/api";
export default {
  components: (_components = {}, _defineProperty(_components, Form.name, Form), _defineProperty(_components, Field.name, Field), _defineProperty(_components, Button.name, Button), _defineProperty(_components, Uploader.name, Uploader), _components),
  data: function data() {
    return {
      complaint: "",
      // 备注
      fileUrlList: [],
      recognized: false,
      uploaded: false
    };
  },
  mounted: function mounted() {},
  methods: {
    // 提交记录
    onSubmit: function onSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var fileList, params, spaceRes;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.fileUrlList.length && !_this.complaint)) {
                  _context.next = 3;
                  break;
                }

                _this.$toast("请上传图片或填写反馈意见");

                return _context.abrupt("return", false);

              case 3:
                fileList = _this.fileUrlList.map(function (el) {
                  return {
                    fileUrl: el.content,
                    fileName: el.file.name,
                    fileFormat: el.file.type
                  };
                });
                params = {
                  complaint: _this.complaint,
                  fileList: fileList
                };
                _context.next = 7;
                return Api.chronic.saveFeedback(params);

              case 7:
                spaceRes = _context.sent;

                if (spaceRes.success) {
                  _this.$toast.success("提交反馈意见成功"); // this.$router.push({
                  // 	name: Routers.CHRONIC_PERSON,
                  // });

                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    beforeRead: function beforeRead(file) {
      if (file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png") {
        return this.$Utils.compressorImg(file, 1024 * 5);
      } else {
        this.$toast("请上传“png、jpg、jpeg”格式图片");
        return false;
      }
    },
    afterRead: function afterRead(e) {
      var _this2 = this;

      console.log("The file:", e);
      e.status = "uploading";
      e.message = "上传中...";
      this.$Utils.uploadImg(e, function (res) {
        if (!res || !res.success) {
          _this2.uploaded = true;
          _this2.recognized = false;

          _this2.$toast("图片上传失败");

          _this2.fileUrlList.pop();

          return;
        }

        _this2.recognized = true;
        e.status = "";
        e.message = "";
        var _res$data = res.data,
            serverUrl = _res$data.serverUrl,
            fileId = _res$data.fileId;
        var url = serverUrl + fileId;
        var len = _this2.fileUrlList.length;
        _this2.fileUrlList[len - 1].content = url;
      });
    }
  }
};